(() => {
  const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[:\s]+/g, ' ').trim();
  function organizeDescription(root) {
    const description = root.querySelector('[data-info-description]');
    const facts = root.querySelector('[data-info-facts]');
    if (!description) return;
    const firstHeading = description.firstElementChild;
    if (firstHeading && /^H[1-6]$/.test(firstHeading.tagName) && description.dataset.productTitle && normalize(firstHeading.textContent) === normalize(description.dataset.productTitle)) firstHeading.remove();
    const headings = [...description.children].filter(node => /^H[2-4]$/.test(node.tagName));
    const heading = headings.find(node => ['materiales y medidas', 'medidas y materiales'].includes(normalize(node.textContent)));
    const list = heading?.nextElementSibling;
    if (!list || list.tagName !== 'UL') return;
    const items = [...list.children];
    if (!items.length || items.some(item => item.tagName !== 'LI' || !item.querySelector(':scope > strong') || item.querySelector('img,table,ul,ol'))) return;
    if (!facts) {
      heading.remove();
      list.remove();
      return;
    }
    let parameters = facts.querySelector('dl');
    if (!parameters) {
      parameters = document.createElement('dl');
      parameters.className = 'cotigo-info__materials';
      facts.prepend(parameters);
    }
    const known = new Set([...parameters.querySelectorAll('dt')].map(node => normalize(node.textContent)));
    items.forEach(item => {
      const label = item.querySelector(':scope > strong');
      const key = normalize(label.textContent);
      const isChain = ['cadena', 'longitud', 'longitud de cadena', 'extension'].includes(key);
      if (isChain && facts.dataset.chainIncluded === 'false') return;
      if (known.has(key)) return;
      if (key === 'longitud' && known.has('longitud de cadena') && known.has('extension')) return;
      const clone = item.cloneNode(true);
      clone.querySelector(':scope > strong').remove();
      if (!clone.textContent.trim()) return;
      const row = document.createElement('div');
      row.className = 'cotigo-info__material-row';
      const term = document.createElement('dt');
      term.textContent = label.textContent.trim().replace(/:$/, '');
      const definition = document.createElement('dd');
      definition.append(...clone.childNodes);
      row.append(term, definition);
      parameters.append(row);
      known.add(key);
    });
    heading.remove();
    list.remove();
  }
  function initialize(root) {
    if (root.classList.contains('is-ready')) return;
    organizeDescription(root);
    const tabs = [...root.querySelectorAll('[data-info-tab]')];
    const panels = [...root.querySelectorAll('[data-info-panel]')];
    const nav = root.querySelector('.cotigo-info__nav');
    if (!tabs.length || !panels.length || !nav) return;
    const desktop = matchMedia('(min-width:750px)');
    const controller = new AbortController();
    const listenerOptions = { signal: controller.signal };
    let active = panels[0].dataset.infoPanel;
    const select = (key, focus = false) => {
      active = key;
      panels.forEach(panel => { panel.open = panel.dataset.infoPanel === key; });
      tabs.forEach(tab => {
        const selected = tab.dataset.infoTab === key;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        if (selected && focus) tab.focus();
      });
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab.dataset.infoTab), listenerOptions);
      tab.addEventListener('keydown', event => {
        let target;
        if (event.key === 'ArrowDown') target = (index + 1) % tabs.length;
        if (event.key === 'ArrowUp') target = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = tabs.length - 1;
        if (target !== undefined) {
          event.preventDefault();
          select(tabs[target].dataset.infoTab, true);
        }
      }, listenerOptions);
    });
    panels.forEach(panel => {
      panel.addEventListener('toggle', () => {
        if (desktop.matches || !panel.open) return;
        active = panel.dataset.infoPanel;
        panels.forEach(other => { if (other !== panel) other.open = false; });
      }, listenerOptions);
    });
    const sync = () => {
      if (desktop.matches) {
        nav.setAttribute('role', 'tablist');
        nav.setAttribute('aria-orientation', 'vertical');
        tabs.forEach(tab => tab.setAttribute('role', 'tab'));
        panels.forEach(panel => {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', 'InfoTab-' + root.id.slice('CotigoInfo-'.length) + '-' + panel.dataset.infoPanel);
        });
        select(active);
      } else {
        nav.removeAttribute('role');
        nav.removeAttribute('aria-orientation');
        tabs.forEach(tab => tab.removeAttribute('role'));
        panels.forEach(panel => {
          panel.removeAttribute('role');
          panel.removeAttribute('aria-labelledby');
        });
      }
    };
    desktop.addEventListener('change', sync, listenerOptions);
    document.addEventListener('shopify:block:select', event => {
      const panel = panels.find(item => item === event.target || item.contains(event.target));
      if (panel) {
        select(panel.dataset.infoPanel);
        if (!desktop.matches) panel.open = true;
      }
    }, listenerOptions);
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) controller.abort();
    }, listenerOptions);
    root.classList.add('is-ready');
    sync();
  }
  const scan = () => document.querySelectorAll('.cotigo-info').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();

